/*****************************************************************************************************************************************************
 * Diagnostic hopping monitoring *
 ****************************************************************************************************************************************************/
define('commons/monitoring/diagnostic-hopping-monitoring',['jquery', 'commons/monitoring/base-monitoring'], function($, BaseMonitoring) {
    var DiagnosticHoppingMonitoring = function(args) {
        // Call parent init method
        BaseMonitoring.apply(this, Array.prototype.slice.call(arguments, 1));
        var size = Math.floor((args[2] - args[1]) / args[3]) + 1;
        var array1 = Array.apply(null, new Array(size)).map(Number.prototype.valueOf, NaN);
        var array2 = Array.apply(null, new Array(size)).map(Number.prototype.valueOf, NaN);
        var array3 = Array.apply(null, new Array(size)).map(Number.prototype.valueOf, NaN);
        var array4 = Array.apply(null, new Array(size)).map(Number.prototype.valueOf, 0);
        var arrayCount = Array.apply(null, new Array(size)).map(Number.prototype.valueOf, 0);
        this.values = {
            data: {
                averageMeanSpec: array1,
                minMeanSpec: array2,
                maxMeanSpec: array3
            },
            linearSum: array4,
            count: arrayCount,
            start: args[1],
            end: args[2],
            step: args[3]
        };
    };

    // Inherit from MessageMonitoring
    for ( var element in BaseMonitoring.prototype) {
        DiagnosticHoppingMonitoring.prototype[element] = BaseMonitoring.prototype[element];
    }

    var darkenColor = function(colorStr) {
        // Defined in dygraph-utils.js
        var color = Dygraph.toRGB_(colorStr);
        color.r = Math.floor((255 + color.r) / 2);
        color.g = Math.floor((255 + color.g) / 2);
        color.b = Math.floor((255 + color.b) / 2);
        return 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')';
    };

    // Multiple column bar chart
    var multiColumnBarPlotter = function(e) {
        // We need to handle all the series simultaneously.
        if (e.seriesIndex !== 0)
            return;

        var g = e.dygraph;
        var ctx = e.drawingContext;
        var sets = e.allSeriesPoints;
        var y_bottom = e.dygraph.toDomYCoord(0);

        // Find the minimum separation between x-values.
        // This determines the bar width.
        var min_sep = Infinity;
        for (var j = 0; j < sets.length; j++) {
            var points = sets[j];
            for (var i = 1; i < points.length; i++) {
                var sep = points[i].canvasx - points[i - 1].canvasx;
                if (sep < min_sep)
                    min_sep = sep;
            }
        }
        var bar_width = Math.floor(2.0 / 3 * min_sep);

        var fillColors = [];
        var strokeColors = g.getColors();
        for (var i = 0; i < strokeColors.length; i++) {
            fillColors.push(darkenColor(strokeColors[i]));
        }

        for (var j = 0; j < sets.length; j++) {
            ctx.fillStyle = fillColors[j];
            ctx.strokeStyle = strokeColors[j];
            for (var i = 0; i < sets[j].length; i++) {
                var p = sets[j][i];
                var center_x = p.canvasx;
                var x_left = center_x - (bar_width / 2) * (1 - j / (sets.length - 1));

                ctx.fillRect(x_left, p.canvasy, bar_width / sets.length, y_bottom - p.canvasy);

                ctx.strokeRect(x_left, p.canvasy, bar_width / sets.length, y_bottom - p.canvasy);
            }
        }
    };

    DiagnosticHoppingMonitoring.prototype.loadData = function(params) {
        this.chart.addClass("loading");
        var result = this.processResponse(this.values);
        if (result && result.data.length > 0) {
            if (this.dygraph == null) {
                this.chart.css("text-align", "left").css("height", this.chart.data('height')).empty();
                this.dygraph = new Dygraph(this.chart.get(0), result.data, $.extend({
                    labels: result.labels,
                    fillGraph: true,
                    labelsDiv: this.label.get(0),
                    hideOverlayOnMouseOut: false,
                    legend: "always",
                    axisLabelFontSize: 12,
                    panEdgeFraction: 0.1,
                    plotter: multiColumnBarPlotter,
                    xRangePad: 800 / result.data.length,
                    axisLabelFormatter: function(d, gran) {
                        return d;
                    }
                }, result.drawOptions));
            } else {
                this.dygraph.updateOptions({
                    labels: result.labels,
                    file: result.data
                });
            }
        } else {
            this.chart.css("text-align", "center").css("height", "auto").html("No data to display");
            this.dygraph = null;
        }
        this.chart.removeClass("loading");
    };

    DiagnosticHoppingMonitoring.prototype.processResponse = function(result) {
        var start = parseInt(result.start);
        var step = parseInt(result.step);
        var data = [];
        var labels = ["Frequency"];

        var tmpData = [];
        var transformers = [];
        if (this.wildcardKey) {
            // use scope in data to build labels
            for ( var key in result.data) {
                var d = result.data[key];
                tmpData.push(d);
                transformers.push(this.transformers[key] ? this.transformers[key] : this.identity);
                labels.push(key);
            }
        } else {
            // Keys and labels of a given mapping key have the same length
            for (var i = 0; i < this.mapping.keys.length; i++) {
                var key = this.mapping.keys[i];
                var d = result.data[key];
                if (d) {
                    tmpData.push(d);
                    transformers.push(this.transformers[key] ? this.transformers[key] : this.identity);
                    labels.push(this.mapping.labels[i]);
                }
            }
        }
        if (tmpData.length > 0) {
            // Data from a given mapping key have the same length
            for (var i = 0; i < tmpData[0].length; i++) {
                var dataRow = [];
                for (var j = 0; j < tmpData.length; j++) {
                    dataRow[j] = (isNaN(tmpData[j][i]) ? 0 : transformers[j](tmpData[j][i]));
                }
                // last time is in seconds and Date object in milliseconds
                var freq = start + (step * i);
                data.push($.merge([freq], dataRow));
            }
        }

        var drawOptions = $.extend({
            stepPlot: true
        }, this.drawOptions);

        return {
            data: data,
            labels: labels,
            drawOptions: drawOptions
        };
    };

    return DiagnosticHoppingMonitoring;
});
